export const DASHBOARD_LINK = '/';
export const SCENE_LINK = '/scenes';
export const TOUR_LINK = '/tours';
export const DRAFT_TOUR_LINK = '/draft-tours';
export const CONFIG_TOUR_LINK = '/tour/:code';
export const CONFIG_TOUR_MINI_MAP_LINK = `${CONFIG_TOUR_LINK}/floorplan`;
export const TOUR_GUIDE_CONFIG = '/tour-guides';
export const NOT_FOUND_LINK = '/404';
export const ACCOUNT_LINK = '/account';
export const ICON_LIBRARY = '/icon-library';
export const THEME_LINK = '/themes';
export const USER_CONTACTS = '/user-contacts';
export const ADMIN_SCENE_LINK = '/admin/scenes';
export const ADMIN_TOUR_LINK = '/admin/tours';
export const CMS_WEB_ROTATE_LINK = '/admin/web-rotate';
export const ADMIN_POI_TEMPLATE = '/poi-template';
export const ITEM_INFO_LINK = '/item-infos';
export const PROMOTION_LINK = '/promotions';
